import { jsx as _jsx } from "react/jsx-runtime";
import moment from 'moment';
import { useSelector } from 'react-redux';
import { CampaignLastSavedInfo } from './campaign-last-saved-info';
import { useSession } from '../../../../../infra/session/use-session';
import { useApiQuery } from '../../../../../infra/api/hooks/use-api-query';
import { useRouteParams } from '../../../../../infra/routing/use-route-params';
import { endpoints } from '../../../network';
import { getTimezone, getViewerIdAndKind } from '../../../../../infra/session/selectors';
import config from '../../../../../../config';
import { getActiveCampaign } from '../../store/selectors';
import { isShopSessionView, userKinds } from '../../../../../infra/session';
import { useProgressIndicator } from '../header/use-progress';
export var CampaignLastSavedInfoContainer = function () {
    var _a, _b, _c;
    var session = useSession().data;
    var steps = useProgressIndicator().steps;
    var timezone = getTimezone(session);
    var viewerIdAndKind = getViewerIdAndKind(session);
    var campaignId = useRouteParams().campaignId;
    var campaign = useApiQuery({
        endpoint: endpoints.campaignByIdQuery,
        payload: {
            campaignId: campaignId,
            ownerId: viewerIdAndKind.id,
            ownerType: viewerIdAndKind.kind,
        },
    }).data;
    var _d = useSelector(getActiveCampaign), isNewCampaign = _d.isNewCampaign, isDraft = _d.isDraft;
    var isTypeStepActive = (_a = steps === null || steps === void 0 ? void 0 : steps.find(function (s) { return s.automationIdPart === 'type'; })) === null || _a === void 0 ? void 0 : _a.active;
    var shouldHide = (isNewCampaign && isDraft) || isTypeStepActive || viewerIdAndKind.kind === 'brand';
    if (shouldHide) {
        return null;
    }
    var _e = (_b = campaign === null || campaign === void 0 ? void 0 : campaign.updatedBy) !== null && _b !== void 0 ? _b : {}, username = _e.username, thumbnail = _e.thumbnail, timestamp = _e.timestamp, firstName = _e.firstName, lastName = _e.lastName, userId = _e.userId, kind = _e.kind;
    var lastModifiedDate = moment.tz(timestamp, timezone).format(config.longDateTimeFormat);
    var nameShown = (function () {
        var isShopOwner = isShopSessionView(session.view) && userId === (session === null || session === void 0 ? void 0 : session.user.id);
        if (isShopOwner)
            return 'Shop Owner';
        if (kind === userKinds.barber)
            return firstName;
        return username;
    })();
    return (_jsx(CampaignLastSavedInfo, { date: lastModifiedDate, id: campaignId, photoUrl: thumbnail, lastName: lastName, firstName: nameShown !== null && nameShown !== void 0 ? nameShown : (_c = campaign === null || campaign === void 0 ? void 0 : campaign.createdBy) === null || _c === void 0 ? void 0 : _c.name }));
};
